// extracted by mini-css-extract-plugin
export default {"App":"Support_App__JcWsH","hr":"Support_hr__Y4LLC","input":"Support_input__DNAxt","button":"Support_button__ka5Yg"};